import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';
import './Header.css';

const navLinks = [
  { label: 'Ana Sayfa', to: '/' },
  { label: 'Hakkında', to: '/#about' },
  { label: 'Yardım', to: '/help' },
  { label: 'Geri Bildirim', to: '/feedback' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <div className="header__inner container">
        <Link to="/" className="header__logo">
          <Logo color="#4A70D8" height={38} />
        </Link>

        <nav className={`header__nav${menuOpen ? ' header__nav--open' : ''}`}>
          {navLinks.map(link => (
            <Link
              key={link.label}
              to={link.to}
              className={`header__link${
                link.to === '/' && location.pathname === '/'
                  ? ' header__link--active'
                  : link.to !== '/' && location.pathname === link.to.split('#')[0]
                    ? ' header__link--active'
                    : ''
              }`}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className={`header__burger${menuOpen ? ' header__burger--open' : ''}`}
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Menüyü aç/kapat"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
